// eslint-disable-next-line no-restricted-imports
import { Text, Title, createStyles, useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

import { PrimaryButtonLink } from '~/domains/common/components/Button/Button';
import { Button } from '~/domains/design-system/Button';

const useStyles = createStyles((theme) => ({
  wrapper: {
    height: '100%',
    minHeight: 320,
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  description: {
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 0,
    fontSize: 16,
    color: theme.colors.gray[4],
    [theme.fn.smallerThan('md')]: {
      fontSize: 12,
    },
  },
}));

function MyContestsError() {
  const { t } = useTranslation('contest');
  const { classes } = useStyles();
  const theme = useMantineTheme();

  return (
    <div className={classes.wrapper}>
      <Title fw={800} order={2} fz={{ base: 24, md: 40 }} c={theme.colors.gray[4]}>
        {t('myContests.states.error.title')}
      </Title>
      <Text component="p" className={classes.description}>
        {t('myContests.states.error.subtitle1')}
      </Text>
      <Text component="p" className={classes.description}>
        {t('myContests.states.error.subtitle2')}
      </Text>

      <Button
        style={{ marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ 60 }}
        variant="primary-fill"
        onClick={() => window.location.reload()}
      >
        {t('myContests.states.error.action')}
      </Button>
    </div>
  );
}

export default MyContestsError;
